import * as ActionTypes from '../ActionTypes';

const initialState = {
    studyprogram_options: [],
    success_message: ""
};

const StudyProgramReducer = function (state = initialState, action) {
    switch (action.type) {
        case ActionTypes.STUDYPROGRAM_GET_REQUEST:
            return {
                ...state,
                studyprogram_options: []
            };
        case ActionTypes.STUDYPROGRAM_GET_SUCCESS:
            return {
                ...state,
                success_message: action.payload.message,
                error: action.payload.has_error,
                studyprogram_options: action.payload?.data?.data
            };
        case ActionTypes.STUDYPROGRAM_ADD_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: false,
                success: false,
            };
        case ActionTypes.STUDYPROGRAM_ADD_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                studyprogram_options: action.payload?.data?.data
            };
        case ActionTypes.STUDYPROGRAM_ADD_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action?.payload?.hasError,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };
        case ActionTypes.STUDYPROGRAM_UPDATE_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: false,
                success: false,
            };
        case ActionTypes.STUDYPROGRAM_UPDATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                studyprogram_options: action.payload?.data?.data
            };
        case ActionTypes.STUDYPROGRAM_UPDATE_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action?.payload?.hasError,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };
        case ActionTypes.STUDYPROGRAM_DELETE_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: false,
                success: false,
            };
        case ActionTypes.STUDYPROGRAM_DELETE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                studyprogram_options: action.payload?.data?.data
            };
        case ActionTypes.STUDYPROGRAM_DELETE_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action?.payload?.hasError,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };
        default:
            return state;
    }
}

export default StudyProgramReducer;